// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1btj4","label":"styles_label__2m9Da"};